"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const ReactComment = ({
  app = "globalnav",
  text
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: `<!-- [${app}:fragment:${text}] -->`
    }
  });
};
const NavFragment = ({
  type,
  children
}) => {
  let _after = null;
  let _before = null;
  React.Children.forEach(children, (child) => {
    if ((child == null ? void 0 : child.type) === NavFragment.Before) {
      return _before = /* @__PURE__ */ React.cloneElement(child, {
        type
      });
    }
    if ((child == null ? void 0 : child.type) === NavFragment.After) {
      return _after = /* @__PURE__ */ React.cloneElement(child, {
        type
      });
    }
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, _before, /* @__PURE__ */ React.createElement(ReactComment, {
    text: type
  }), _after);
};
const Before = ({
  children,
  type
}) => {
  if (typeof window === "undefined") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReactComment, {
      app: "client",
      text: `${type}:before`
    }), children, /* @__PURE__ */ React.createElement(ReactComment, {
      app: "client",
      text: `${type}:before`
    }));
  }
  return null;
};
const After = ({
  children,
  type
}) => {
  if (typeof window === "undefined") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReactComment, {
      app: "client",
      text: `${type}:after`
    }), children, /* @__PURE__ */ React.createElement(ReactComment, {
      app: "client",
      text: `${type}:after`
    }));
  }
  return null;
};
NavFragment.Before = Before;
NavFragment.After = After;
exports.NavFragment = NavFragment;
